import { injectLocationApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/location.service';
import { baseApi } from '@service/base.api';

export const locationApi = injectLocationApi(baseApi);

export const {
  useGetLocationsPaginatedQuery,
  useGetLocationQuery,
  usePullCpoLocationsMutation,
  useGetConnectorQuery,
  useGetEvseQuery,
} = locationApi;
